import { debounce } from '../utility/limiters.js';

const initialisedCards = new Set();

class EventCard {
    constructor( card ) {
        this.el = card;
        this.picture = card.querySelector( '.card__picture' );
        this.description = card.querySelector( '.card__description' );

        this.el.addEventListener( 'mouseover', this.open, { once: true } );
        this.heightTimeout = false;
    }

    open = () => {
        this.el.style.height = this.el.offsetHeight + 'px';
        this.picture.style.padding = 0;

        clearTimeout( this.heightTimeout );
        this.el.addEventListener( 'mouseleave', this.close, { once: true } );
    };

    close = () => {
        this.picture.style.padding = null;
        this.el.addEventListener( 'mouseover', this.open, { once: true } );

        this.heightTimeout = setTimeout( () => {
            this.el.style.height = null;
        }, 600 );
    };
}

export function setUpEventCardEvents() {
    document.querySelectorAll( '.card--event' ).forEach( card => {
        if ( initialisedCards.has( card ) ) return;
        initialisedCards.add( card );
        new EventCard( card );
    } );
}

setUpEventCardEvents();

